// Custom SVG icon for TinyMCE editor
// TinyMCE requires SVG as a string, so we keep it as a string export
// but store it in a separate file for better organization
export const customIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1402_772)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0209 6.70598C14.6303 6.31545 13.9972 6.31545 13.6067 6.70598L3.70715 16.6055C3.31663 16.996 3.31663 17.6292 3.70715 18.0197L5.82847 20.141C6.219 20.5315 6.85216 20.5315 7.24269 20.141L17.1422 10.2415C17.5327 9.85099 17.5327 9.21782 17.1422 8.8273L15.0209 6.70598ZM16.4351 9.53426L14.3138 7.41293L11.4853 10.2414L13.6067 12.3627L16.4351 9.53426Z" fill="black"/>
  <path d="M18.52 7.33333L17.8307 5.75972L16.32 5.04167L17.8307 4.32361L18.52 2.75L19.2093 4.32361L20.72 5.04167L19.2093 5.75972L18.52 7.33333Z" fill="black"/>
  <path d="M18.52 16.5003L17.8307 14.9267L16.32 14.2087L17.8307 13.4906L18.52 11.917L19.2093 13.4906L20.72 14.2087L19.2093 14.9267L18.52 16.5003Z" fill="black"/>
  <path d="M9.72 7.33333L9.03066 5.75972L7.52 5.04167L9.03066 4.32361L9.72 2.75L10.4093 4.32361L11.92 5.04167L10.4093 5.75972L9.72 7.33333Z" fill="black"/>
  </g>
  <defs>
  <clipPath id="clip0_1402_772">
  <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
</svg>`;

// For React component usage (if needed elsewhere in the app)
export const CustomIconReact = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1402_772)">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.0209 6.70598C14.6303 6.31545 13.9972 6.31545 13.6067 6.70598L3.70715 16.6055C3.31663 16.996 3.31663 17.6292 3.70715 18.0197L5.82847 20.141C6.219 20.5315 6.85216 20.5315 7.24269 20.141L17.1422 10.2415C17.5327 9.85099 17.5327 9.21782 17.1422 8.8273L15.0209 6.70598ZM16.4351 9.53426L14.3138 7.41293L11.4853 10.2414L13.6067 12.3627L16.4351 9.53426Z" fill="black"/>
      <path d="M18.52 7.33333L17.8307 5.75972L16.32 5.04167L17.8307 4.32361L18.52 2.75L19.2093 4.32361L20.72 5.04167L19.2093 5.75972L18.52 7.33333Z" fill="black"/>
      <path d="M18.52 16.5003L17.8307 14.9267L16.32 14.2087L17.8307 13.4906L18.52 11.917L19.2093 13.4906L20.72 14.2087L19.2093 14.9267L18.52 16.5003Z" fill="black"/>
      <path d="M9.72 7.33333L9.03066 5.75972L7.52 5.04167L9.03066 4.32361L9.72 2.75L10.4093 4.32361L11.92 5.04167L10.4093 5.75972L9.72 7.33333Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_1402_772">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
